import { Box, styled } from '@mui/material';
import { HiOutlineArchive } from 'react-icons/hi';
import {
  WsDetailsObj,
  WsIconLocation,
  WsIconJobOutline,
  WsIconPersons,
  WsIconVisa,
  WsColors,
  WsIconCurrency,
  WsIconDice,
  WsIconLikeLocation,
  WsSelectObj,
} from 'wisestep-base';

import { failed, success, warning } from '../../../../utils/NotificationMessages';

export const LayoutTheme = styled(Box)(() => ({
  maxWidth: '100%',
  maxHeight: 'xs',
  backgroundColor: WsColors.TertiaryShades50,
}));

export const AppLayoutTheme = styled(Box)(() => ({
  borderRadius: 8,
  backgroundColor: WsColors.TheBlues900,
}));

export enum CandidateType {
  SUBMISSIONS = 'submissions',
  TALENTPOOL = 'talentpool',
  PIPELINE = 'pipeline',
  SMART_SOURCE = 'smartSource',
}

export const copySuccess = () => success('Copied Successfully !!');
export const copyFailed = () => failed('Copy failed !! ');
export const copyWarn = () => warning('Clipboard not supported');

export const getBotCandidateDetails = (candidate): WsDetailsObj[] => {
  const array: WsDetailsObj[] = [];
  array.push({
    icon: <WsIconLocation />,
    labelName:
      `${
        (candidate.City ? candidate.City : '') + ',' + (candidate.Country ? candidate.Country : '')
      }` ?? 'Not Available',
    popOverText: 'Candidate Location',
  });
  array.push({
    icon: <WsIconJobOutline />,
    labelName: candidate.JobTitle ?? 'Not Available',
    popOverText: 'Candidate Profile',
  });
  array.push({
    icon: <WsIconPersons />,
    labelName:
      (candidate.TotalExperience &&
        `${candidate.TotalExperience} Year Experience ${
          candidate.USExperience ? ',US-Experience :' + candidate.USExperience + ' Years' : ''
        }`) ??
      'Not Available',
    popOverText: 'Candidate Experience',
  });

  array.push({
    icon: <WsIconCurrency />,
    labelName: `Candidate Salary: ${candidate.Salary ?? 'Not Available'} (Rate:${
      candidate.Rate ?? 'Not Available'
    } )`,
    popOverText: 'Candidate Salary',
  });

  array.push({
    icon: <WsIconLocation />,
    labelName: `Candidate Willing To Relocate: ${candidate.Relocation ?? 'Not Available'}`,
    popOverText: 'Candidate Willing To relocate',
  });
  array.push({
    icon: <WsIconVisa />,
    labelName: candidate.WorkAuthorization ?? 'Not Available',
    popOverText: 'Candidate Visa',
  });
  return array;
};

export const SmallBoxWithRadius = styled(Box)(() => ({
  border: '1px solid ',
  borderColor: WsColors.TheBlues500,
  borderRadius: 8,
  paddingLeft: 8,
  paddingRight: 8,
  height: 25,
  alignItems: 'center',
}));

export const getTechFetchCandidateDeatails = (candidate) => {
  const array = [
    {
      icon: <WsIconLocation />,
      label: `${candidate.State}-${candidate.Zipcode}`,
      tooltip: 'Candidate Locaion',
    },

    {
      icon: <WsIconJobOutline />,
      label: `${candidate.candidateData.currentJobTitle}${
        candidate.candidateData.currentEmployer
          ? '@ ' + candidate.candidateData.currentEmployer
          : ''
      }`,
      tooltip: 'Current Job Title',
    },
    {
      icon: <WsIconPersons />,
      label: `${candidate.TotalExperience} years`,
      tooltip: 'Candidate Total experience',
    },
    {
      icon: <WsIconLikeLocation color={WsColors.TertiaryShades700} />,
      label: `Willing to Relocate: ${candidate.Relocation}`,
      tooltip: 'Relocation',
    },
    {
      icon: <HiOutlineArchive size={16} color={WsColors.TertiaryShades700} />,
      label: `PreferredEmployment :${candidate.PreferredEmployment}`,
      tooltip: 'Candidate Locaion',
    },
    {
      icon: <WsIconVisa />,
      label: `Work Authorization: ${candidate.WorkAuthorization}`,
      tooltip: 'Work Authorization',
    },
    {
      icon: <WsIconCurrency />,
      label: `Rate: ${candidate.Rate}`,
      tooltip: 'Candidate Expected Salary',
    },
    {
      icon: <WsIconCurrency />,
      label: `Salary: ${candidate.Salary}`,
      tooltip: 'Candidate Current Salary',
    },
    {
      icon: <WsIconDice />,
      label: `Source: ${candidate.candidateData.source}`,
      tooltip: 'Source',
    },
  ];
  return array;
};

export const searchPatternOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Match All Keywords',
    value: 'All',
  },
  {
    label: 'Match Any Keyword',
    value: 'Any',
  },
];

export const willingRelocateOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Yes',
    value: 'Yes',
  },
  {
    label: 'No',
    value: 'No',
  },
];

export const workAuthorizationCheckBoxOptions = {
  'US Citizen': 'US Citizen',
  'Green Card': 'Green Card',
  'H1B Work Permit': 'H1B Work Permit',
  'OPT EAD': 'OPT EAD',
  'CPT EAD': 'CPT EAD',
  'GC EAD': 'GC EAD',
  'L2 EAD': 'L2 EAD',
  'H4 EAD': 'H4 EAD',
  'TN EAD': 'TN EAD',
};

export const experiencesCheckBoxOptions = {
  Any: 'Any',
  Junior: 'Junior',
  Middle: 'Middle',
  Senior: 'Senior',
  Architect: 'Architect',
};

export const degreeCheckBoxOptions = {
  PreBachelor: 'PreBachelor',
  Bachelor: 'Bachelor',
  Master: 'Master',
  Doctorate: 'Doctorate',
};

export const prefferedEmployedCheckBoxOptions = {
  'Corp-Corp': 'Corp-Corp',
  'W2-Contract': 'W2-Contract',
  'W2-Permanent': 'W2-Permanent',
  '1099-Contract': '1099-Contract',
  'H1B Transfer': 'H1B Transfer',
};

export const usExperienceCheckBoxOptions = {
  Any: 'Any',
  Junior: 'Junior',
  Middle: 'Middle',
  Senior: 'Senior',
  Architect: 'Architect',
};

export const domainExposureCheckBoxOptions = {
  'IT/Software': 'IT/Software',
  'Dot Com': 'Dot Com',
  Finance: 'Finance',
  Insurance: 'Insurance',
  Government: 'Government',
  Pharmaceuticals: 'Pharmaceuticals',
  Healthcare: 'Healthcare',
  Manufacturing: 'Manufacturing',
  Retail: 'Retail',
  Telecom: 'Telecom',
};
